import { useEffect, useState } from "react";
import axios from "axios";
import WithUser from "../../ContextAndHOC/WithUser";
import { withTranslation } from "react-i18next";
import queryString from "query-string";
import { Navigate } from "react-router";
import { API_MOUNT_PATH } from "../../constants";
import PropTypes from "prop-types";

function AutoLogin({ props }) {
  const { t, changeUser } = props;

  const [renderto, setRenderto] = useState("");

  useEffect(() => {
    const fetchUserDetails = async () => {
      const response = await axios.get(
        `${API_MOUNT_PATH}/providerservice/getUserDetails`
      );
      const { redirectTo } = queryString.parse(window.location.search);
      let observationType;
      if (Array.isArray(response.data.observationType)) {
        for (const obs of response.data.observationType) {
          if (obs.type === 3) {
            observationType = obs.uom;
            break;
          }
        }
      }
      response.data.glucoseUnit =
        observationType?.[0] === 1
          ? t("commonCountrySpecific.COMMON__MG_DL")
          : t("commonCountrySpecific.COMMON__MMOL_L");
      response.data.glucoseUom = observationType?.[0];
      changeUser.changeUser(response.data);

      if (redirectTo) {
        setRenderto(redirectTo.toString().replace("$token", "?token"));
      }
    };
    fetchUserDetails();
  }, []);

  return <>{renderto ? <Navigate to={renderto} /> : null}</>;
}

AutoLogin.propTypes = {
  changeUser: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(WithUser(AutoLogin));
